import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "text-justify" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.titles, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "my-3"
      }, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t("lean.ranking.attributes.title", {
            pt: item.title.pt,
            en: item.title.en,
          })), 1),
        _createElementVNode("label", _hoisted_2, "• " + _toDisplayString(_ctx.$t("lean.ranking.attributes.subtitle", {
            pt: item.subtitle.pt,
            en: item.subtitle.en,
          })), 1)
      ]))
    }), 128))
  ]))
}